import ReactGA from "react-ga4";

export const initGA = () => {
  if (process.env.NODE_ENV === "production" && process.env.REACT_APP_GA_ID) {
    ReactGA.initialize(process.env.REACT_APP_GA_ID, {
      gaOptions: {
        // Prevents double pageviews on SPAs
        send_page_view: false,
      },
    });
  }
};
